import React from "react";

import PropTypes from "prop-types";

import Link from "../atoms/Link";
import Section from "../layouts/Section";

import styles from "./ConfirmationCodePopupAction.module.scss";

function ConfirmationCodePopupAction({ prompt, cta, link, onClick }) {
  return (
    <Section horizontalPosition="center">
      {prompt}
      <Link
        href={link}
        underline
        dark
        className={styles.link}
        onClick={onClick}
      >
        {cta}
      </Link>
    </Section>
  );
}

ConfirmationCodePopupAction.propTypes = {
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  cta: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
};
ConfirmationCodePopupAction.defaultProps = {
  link: "",
  onClick: () => {},
};

export default ConfirmationCodePopupAction;
